import React, { useEffect, useState, useMemo } from "react";
import { a } from "react-router-dom";
import logo from "./assets/img/AYVVA_BLACK _LOGO.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getCartWishlistLength,
  getSearchProducts,
} from "../App/Slices/productSlice";
import { isAuthenticated } from "../App/utils/auth";
import { getGuestCartCount } from "../App/appUtils/cartStorage";
import { getActiveCategories } from "../App/Slices/categoriesSlice";
import debounce from "lodash.debounce";

const Header = () => {
  const dispatch = useDispatch();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mensData, setMensData] = useState([]);
  const [womensData, setWomensData] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const {
    searchproducts,
    cartCount,
    wishlistCount,
    isSearchLoading,
  } = useSelector((state) => state.productsData);
  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const [guestCartCount, setGuestCartCount] = useState(getGuestCartCount());

  const { isAuthenticated: logedIn } = useSelector((state) => state.auth);
  // ✅ categories from redux
  const { activeCategories: categories } = useSelector(
    (state) => state.categoriesData
  );

  useEffect(() => {
    if (isAuthenticated() || logedIn) {
      dispatch(getCartWishlistLength());
    }
  }, [dispatch, logedIn]);

  const finalCartCount =
    isAuthenticated() || logedIn ? cartCount : guestCartCount;

  const finalWishlistCount = isAuthenticated() || logedIn ? wishlistCount : 0;

  // ---------------- FETCH CATEGORIES ----------------
  useEffect(() => {
    dispatch(getActiveCategories());
  }, [dispatch]);

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        dispatch(getSearchProducts(value));
      }, 400),
    [dispatch]
  );

  useEffect(() => {
    if (!search.trim()) return;

    debouncedSearch(search);

    return () => {
      debouncedSearch.cancel(); // cleanup
    };
  }, [search, debouncedSearch]);

  // ---------------- SPLIT MEN / WOMEN ----------------
  useEffect(() => {
    if (!categories || categories.length === 0) return;

    const menCategory = categories.find(
      (cat) => cat.title.toLowerCase() === "men"
    );

    const womenCategory = categories.find(
      (cat) => cat.title.toLowerCase() === "women"
    );

    setMensData(menCategory?.children || []);
    setWomensData(womenCategory?.children || []);
  }, [categories]);

  useEffect(() => {
    const updateGuestCount = () => {
      setGuestCartCount(getGuestCartCount());
    };

    // Listen for custom guest cart update events
    window.addEventListener("guest-cart-updated", updateGuestCount);
    
    // Sync guest cart when page becomes visible (tab focus or back button)
    window.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        updateGuestCount();
      }
    });

    // Sync guest cart on window focus
    window.addEventListener("focus", updateGuestCount);

    return () => {
      window.removeEventListener("guest-cart-updated", updateGuestCount);
      window.removeEventListener("visibilitychange", updateGuestCount);
      window.removeEventListener("focus", updateGuestCount);
    };
  }, []);


  return (
    <div className="w-full fixed z-50 ">
      {/* Top Header Bar */}
      <div className="bg-black text-white py-1 overflow-hidden">
        <div className="relative w-full">
          <div className="animate-marquee whitespace-nowrap flex gap-8 text-xs font-light">
            <span>Need Help? Chat with us on WhatsApp</span>
            <span>|</span>
            <span>Get Exclusive Offers – Subscribe Now!</span>
            <span>|</span>
            <span>Check Delivery Time</span>

            {/* duplicate for seamless loop */}
            <span>Need Help? Chat with us on WhatsApp</span>
            <span>|</span>
            <span>Get Exclusive Offers – Subscribe Now!</span>
            <span>|</span>
            <span>Check Delivery Time</span>

            <span>Need Help? Chat with us on WhatsApp</span>
            <span>|</span>
            <span>Get Exclusive Offers – Subscribe Now!</span>
            <span>|</span>
            <span>Check Delivery Time</span>

            {/* duplicate for seamless loop */}
            <span>Need Help? Chat with us on WhatsApp</span>
            <span>|</span>
            <span>Get Exclusive Offers – Subscribe Now!</span>
            <span>|</span>
            <span>Check Delivery Time</span>
          </div>
        </div>
      </div>

      {/* Logo Section */}
      {/* <nav className="py-3 border-b bg-white shadow-sm">
        <div className="container mx-auto px-4">
        
        </div>
      </nav> */}

      {/* Main Navigation */}
      <nav className="border-b bg-white shadow-sm">
        <div className="container mx-auto">
          <div className="grid grid-cols-3 items-center py-2">
            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden text-black focus:outline-none"
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>

            {/* Desktop Navigation as - Centered */}
            <div className="hidden lg:flex gap-6 mx-auto font-['Playfair_Display'] ">
              <a
                href="/"
                className="text-black hover:text-gray-600 transition-colors duration-300 font-normal text-base no-underline "
              >
                Home
              </a>
              {/* WOMEN DROPDOWN */}
              <div
                className="relative"
                onMouseEnter={() => setOpenDropdown("women")}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <a
                  href="/women"
                  className="text-black hover:text-gray-600 transition-colors duration-300 font-normal text-base no-underline"
                >
                  Women
                </a>

                {openDropdown === "women" && (
                  <div className="absolute top-full left-0 bg-white shadow-lg border min-w-[200px] z-50">
                    {womensData.map((item) => (
                      <a
                        key={item.id}
                        href={`/women?cat=${item.title
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                        className="block px-4 py-2 text-sm text-black hover:bg-gray-100 no-underline"
                      >
                        {item.title}
                      </a>
                    ))}

                    {/* <div className="border-t my-1" /> */}

                    <a
                      href="/women?cat=newarrivals"
                      className="block px-4 py-2 text-sm text-black hover:bg-gray-100 no-underline"
                    >
                      New Arrivals
                    </a>

                    <a
                      href="/women?cat=bestseller"
                      className="block px-4 py-2 text-sm text-black hover:bg-gray-100 no-underline"
                    >
                      Best Seller
                    </a>
                  </div>
                )}
              </div>

              {/* MEN DROPDOWN */}
              <div
                className="relative"
                onMouseEnter={() => setOpenDropdown("men")}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <a
                  href="/men"
                  className="text-black hover:text-gray-600 transition-colors duration-300 font-normal text-base no-underline"
                >
                  Men
                </a>

                {openDropdown === "men" && (
                  <div className="absolute top-full left-0 bg-white shadow-lg border min-w-[200px] z-50">
                    {mensData.map((item) => (
                      <a
                        key={item.id}
                        href={`/men?cat=${item.title
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                        className="block px-4 py-2 text-sm text-black hover:bg-gray-100 no-underline"
                      >
                        {item.title}
                      </a>
                    ))}

                    {/* <div className="border-t my-1" /> */}

                    <a
                      href="/men?cat=newarrivals"
                      className="block px-4 py-2 text-sm text-black hover:bg-gray-100 no-underline"
                    >
                      New Arrivals
                    </a>

                    <a
                      href="/men?cat=bestseller"
                      className="block px-4 py-2 text-sm text-black hover:bg-gray-100 no-underline"
                    >
                      Best Seller
                    </a>
                  </div>
                )}
              </div>

              <a
                href="/about"
                className="text-black hover:text-gray-600 transition-colors duration-300 font-normal text-base no-underline"
              >
                About
              </a>
            </div>

            <div className="">
              <a href="/" className="flex justify-center">
                <img src={logo} alt="Ayvva Logo" className="h-[60px]" />
              </a>
            </div>

            {/* Icons - Right Side */}
            <div className="flex gap-2 items-center ml-auto">
              {/* Search Icon */}
              <div className="relative top-1">
                <button
                  onClick={() => setShowSearch(!showSearch)}
                  className="text-black hover:text-gray-600"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
                {showSearch && (
                  <div
                    className="
      fixed inset-0 lg:absolute lg:inset-auto
      lg:right-0 lg:top-full lg:mt-2
      bg-white lg:w-[280px]
      z-[9999]
      flex flex-col
    "
                  >
                    {/* Mobile Header */}
                    <div className="flex items-center justify-between px-4 py-3 border-b lg:hidden">
                      <p className="font-medium text-sm">Search Products</p>
                      <button onClick={() => setShowSearch(false)}>✕</button>
                    </div>

                    {/* Search Input */}
                    <input
                      type="text"
                      placeholder="Search products..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="w-full px-4 py-3 border-b outline-none text-sm"
                      autoFocus
                    />

                    {/* Suggestions */}
                    <div className="flex-1 max-h-[70vh] lg:max-h-[250px] overflow-y-auto">
                      {isSearchLoading && (
                        <p className="p-4 text-sm text-gray-500">
                          Searching...
                        </p>
                      )}

                      {!isSearchLoading &&
                        searchproducts?.length === 0 &&
                        search && (
                          <p className="p-4 text-sm text-gray-500">
                            No products found
                          </p>
                        )}

                      {searchproducts?.map((item) => (
                        <a
                          key={item._id}
                          href={`/product-details/${item.slug}`}
                          onClick={() => {
                            setShowSearch(false);
                            setSearch("");
                          }}
                          className="flex gap-3 px-4 py-3 hover:bg-gray-100 text-sm no-underline text-black"
                        >
                          <img
                            src={`${BaseUrl}/${item?.main_image}`}
                            alt={item?.title}

                            loading="lazy"
                            decoding="async"
                            draggable="false"
                            className="w-12 h-12 object-cover rounded"
                          />
                          <div>
                            <p className="font-medium">{item.title}</p>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Wishlist Icon */}
              {/* <a href="/wishlist" className="relative">
                <svg
                  className={`w-5 h-5 ${
                    finalWishlistCount > 0
                      ? "fill-red-500 text-red-500"
                      : "fill-none text-black"
                  }`}
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                  />
                </svg>
                {finalWishlistCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] rounded-full min-w-[16px] h-4 flex items-center justify-center px-1.5">
                    {finalWishlistCount}
                  </span>
                )}
              </a> */}

              {/* Cart Icon */}
              <a href="/my-cart" className="relative">
                <svg
                  className="w-5 h-5 text-black"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
                {finalCartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] rounded-full min-w-[16px] h-4 flex items-center justify-center px-1.5">
                    {finalCartCount}
                  </span>
                )}
              </a>

              {/* User Icon */}
              {/* {isAuthenticated() || logedIn ? (
                <a href="/profile">
                  <svg
                    className="w-5 h-5 text-black hover:text-gray-600 transition-colors duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </a>
              ) : (
                <a
                  href="/login"
                  className="text-black hover:text-gray-600 transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Login
                </a>
              )} */}
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden pb-4 font-['Playfair_Display']">
              <div className="flex flex-col gap-3 text-center">
                <a
                  href="/"
                  className="text-black hover:text-gray-600 transition-colors py-1 text-decoration-none "
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </a>
                <div>
                  <button
                    onClick={() =>
                      setOpenDropdown(openDropdown === "women" ? null : "women")
                    }
                    className="w-full text-black hover:text-gray-600 transition-colors py-1"
                  >
                    Women
                  </button>

                  {openDropdown === "women" && (
                    <div className="pl-4">
                       <a
                        href="/women"
                        className="block py-1 text-md text-gray-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        View All
                      </a>

                      {womensData.map((item) => (
                        <a
                          key={item.id}
                          href={`/women?cat=${item.title
                            .toLowerCase()
                            .replace(/\s+/g, "-")}`}
                          className="block py-1 text-md text-gray-700"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {item.title}
                        </a>
                      ))}

                      <a
                        href="/women?cat=newarrivals"
                        className="block py-1 text-md text-gray-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        New Arrivals
                      </a>

                      <a
                        href="/women?cat=bestseller"
                        className="block py-1 text-md text-gray-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Best Seller
                      </a>
                    </div>
                  )}
                </div>

                <div>
                  <button
                    onClick={() =>
                      setOpenDropdown(openDropdown === "men" ? null : "men")
                    }
                    className="w-full text-black hover:text-gray-600 transition-colors py-1"
                  >
                    Men
                  </button>

                  {openDropdown === "men" && (
                    <div className="pl-4">
                        <a
                        href="/men"
                        className="block py-1 text-md text-gray-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        View All
                      </a>
                      {mensData.map((item) => (
                        <a
                          key={item.id}
                          href={`/men?cat=${item.title
                            .toLowerCase()
                            .replace(/\s+/g, "-")}`}
                          className="block py-1 text-md text-gray-700"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {item.title}
                        </a>
                      ))}

                      <a
                        href="/men?cat=newarrivals"
                        className="block py-1 text-md text-gray-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        New Arrivals
                      </a>

                      <a
                        href="/men?cat=bestseller"
                        className="block py-1 text-md text-gray-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Best Seller
                      </a>
                    </div>
                  )}
                </div>

                <a
                  href="/about"
                  className="text-black hover:text-gray-600 transition-colors py-1 text-decoration-none"
                  onClick={() => setIsMenuOpen(false)}
                >
                  About
                </a>
                {/* <a
                  href="/newarrivals"
                  className="text-black hover:text-gray-600 transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  New Arrivals
                </a>
                <a
                  href="/bestseller"
                  className="text-black hover:text-gray-600 transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Best Seller
                </a> */}
              </div>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Header;
